module.exports = __webpack_public_path__ + "img/一键美颜--大图--美颜前.c0fc97d7.png";